<script>
import { required, email } from "vuelidate/lib/validators";
import { sharedHelper } from '@/utils';
import { authMethods } from "@/state/helpers";
import { MEDIUM } from '@/constants/enums';
import { mapState } from "vuex";
import { MODULE } from '@/state/modules/auth'

export default {
  data() {
    return {
      submitted: false,
      loginForm: {
        email: '',
        password: '',
        platform: sharedHelper.getPlatform(),
        domain: sharedHelper.getHostname(),
        option: 1,
        medium: MEDIUM.EMAIL,
      },
    };
  },
  computed: {
    ...mapState(MODULE, ['status']),
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  validations: {
    loginForm: {
      email: { required, email },
      password: { required },
    }
  },
  methods: {
    ...authMethods,
    requestLogin() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.login({ data: this.loginForm });
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-8">
            <div class="auth-hero">
              <div class="auth-hero-overlay"></div>
              <div class="auth-hero-blob auth-hero-blob--a"></div>
              <div class="auth-hero-blob auth-hero-blob--b"></div>
              <div class="auth-hero-content">
                <div class="auth-hero-logo brand-mark">one<strong>inbox</strong></div>
                <h2 class="auth-hero-title">{{ $t('projectName') }}</h2>
                <p class="auth-hero-tagline">{{ $t('label.signInToContinueToProject', [$t('projectName')]) }}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <div class="brand-mark brand-mark-sm">one<strong>inbox</strong></div>
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4 auth-welcome">{{ $t('label.welcomeBack') }}</h4>
                        <p class="text-muted">{{ $t('label.signInToContinueToProject', [$t('projectName')]) }}</p>
                      </div>

                      <div class="p-2 mt-5">
                        <form class="form-horizontal" @submit.prevent="requestLogin">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon auth-icon-purple"></i>
                            <label for="email">{{ $t('label.email') }}</label>
                            <input type="email" v-model="loginForm.email" class="form-control" id="email"
                              :placeholder="$t('label.enter', [$t('label.email')])"
                              :class="{ 'is-invalid': submitted && $v.loginForm.email.$error }" />
                            <div v-if="submitted && $v.loginForm.email.$error" class="invalid-feedback">
                              <span v-if="!$v.loginForm.email.required">{{ $t('message.requiredX', [$t('label.email')])
                              }}</span>
                              <span v-if="!$v.loginForm.email.email">{{ $t('message.validX', [$t('label.email')])
                              }}</span>
                            </div>
                          </div>

                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-lock-2-line auti-custom-input-icon auth-icon-purple"></i>
                            <label for="userpassword">{{ $t('label.password') }}</label>
                            <input v-model="loginForm.password" type="password" class="form-control" id="password"
                              :placeholder="$t('label.enter', [$t('label.password')])"
                              :class="{ 'is-invalid': submitted && $v.loginForm.password.$error }" />
                            <div v-if="submitted && !$v.loginForm.password.required" class="invalid-feedback">{{
                              $t('message.requiredX', [$t('label.password')]) }}</div>
                          </div>

                          <div class="mt-4 text-center">
                            <button class="btn btn-purple-grad w-md waves-effect waves-light" type="submit"
                              :disabled="status.processing">{{ $t('label.login') }}</button>
                          </div>

                          <div class="mt-4 text-center">
                            <router-link tag="a" to="/forgot-password" class="text-muted">
                              <i class="mdi mdi-lock mr-1"></i> {{ $t('label.forgotPassword') }}
                            </router-link>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">

                        <p>
                          © {{ new Date().getFullYear() }} {{ $t('projectName') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.auth-hero {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #5E2FE0 0%, #7C4DFF 55%, #9C6AFF 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-hero-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.18) 0%, transparent 55%),
              radial-gradient(circle at 80% 75%, rgba(0, 0, 0, 0.25) 0%, transparent 65%);
}
.auth-hero-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.55;
  pointer-events: none;
}
.auth-hero-blob--a {
  width: 320px;
  height: 320px;
  background: #B388FF;
  top: -60px;
  left: -60px;
}
.auth-hero-blob--b {
  width: 380px;
  height: 380px;
  background: #5E2FE0;
  bottom: -100px;
  right: -80px;
}
.auth-hero-content {
  position: relative;
  z-index: 1;
  color: #fff;
  text-align: center;
  padding: 0 32px;
}
.auth-hero-logo {
  width: 96px;
  height: 96px;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.18);
  padding: 14px;
  border-radius: 24px;
  backdrop-filter: blur(12px);
  margin-bottom: 24px;
}
.auth-hero-title {
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}
.auth-hero-tagline {
  font-size: 15px;
  opacity: 0.85;
  max-width: 360px;
  margin: 0 auto;
}
.auth-welcome {
  color: #5E2FE0;
  font-weight: 700;
}
.auth-icon-purple {
  color: #7C4DFF !important;
}
.btn-purple-grad {
  background: linear-gradient(135deg, #7C4DFF 0%, #B388FF 100%);
  color: #fff;
  border: none;
  font-weight: 600;
  padding: 10px 36px;
  border-radius: 50px;
  box-shadow: 0 8px 18px rgba(124, 77, 255, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.btn-purple-grad:hover:not(:disabled) {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(124, 77, 255, 0.45);
}
.btn-purple-grad:disabled {
  opacity: 0.7;
}
@media (max-width: 991px) {
  .auth-hero { display: none; }
}
</style>

<style scoped>
/* A wordmark, not an image. The one_sales logo lives in a client's S3 bucket —
   linking it would 404 the day that bucket is tidied, or worse, keep showing
   another company's brand on our login page. */
.brand-mark { font-size: 34px; letter-spacing: -1px; color: #fff; }
.brand-mark strong { font-weight: 700; }
.brand-mark-sm { font-size: 26px; color: #2563eb; }
.brand-mark-sm strong { color: #111827; }
</style>
